import { render, staticRenderFns } from "./SubHeadingCard.vue?vue&type=template&id=26b40058&scoped=true"
import script from "./SubHeadingCard.vue?vue&type=script&lang=js"
export * from "./SubHeadingCard.vue?vue&type=script&lang=js"
import style0 from "./SubHeadingCard.vue?vue&type=style&index=0&id=26b40058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b40058",
  null
  
)

export default component.exports